export function LogoMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path
        d="M6 27L24 9l18 18"
        stroke="#E08838"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 27v11h24V27"
        stroke="#F4F1EA"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.9"
      />
      <path
        d="M17.5 31.5l5 5L31.5 27"
        stroke="#E08838"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ size = 40, withWordmark = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="hale-pono-logo">
      <LogoMark size={size} />
      {withWordmark && (
        <div className="leading-none">
          <span className="block font-display text-lg font-extrabold tracking-tight text-sand">
            HALE PONO
          </span>
          <span className="mt-1 block font-mono text-[9px] uppercase tracking-[0.28em] text-mist">
            Community Support Services
          </span>
        </div>
      )}
    </div>
  );
}
